import React from 'react';
import { motion } from 'framer-motion';
import { Users, Stethoscope, Leaf, ShieldCheck } from 'lucide-react';
export function TrustBar() {
  const badges = [{
    icon: <Users className="w-6 h-6" data-id="element-177" />,
    text: '100.000+ zufriedene Kunden'
  }, {
    icon: <Stethoscope className="w-6 h-6" data-id="element-178" />,
    text: 'Von Tierärzten empfohlen'
  }, {
    icon: <Leaf className="w-6 h-6" data-id="element-179" />,
    text: '100% pflanzlich & natürlich'
  }, {
    icon: <ShieldCheck className="w-6 h-6" data-id="element-180" />,
    text: 'Geld-zurück-Garantie'
  }];
  return <section className="w-full border-y border-brown/10 bg-white py-8 px-4" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4" data-id="element-183">
          {badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center gap-3" data-id="element-184">
              <div className="text-forest bg-forest/5 p-3 rounded-full" data-id="element-185">
                {badge.icon}
              </div>
              <span className="font-serif text-sm md:text-base text-gray-700 font-medium" data-id="element-186">
                {badge.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}